import { algorithms } from './algorithms';
import { toCompactUpperCase } from '@/libs/utils/strings';

export const HCP_ID_STATUS = Object.freeze({ VALID: 'valid', INVALID: 'invalid' });

/**
 * @param {HcpId.RegistrationConfig} config
 * @returns {HcpId.VerificationConfig|undefined}
 */
export function getHcpIdVerificationConfig(config) {
    const verification = config?.event_details?.warning_wall_config?.hcp_verification;
    return verification?.rules ? verification : undefined;
}

/**
 * @param {string} number
 * @param {HcpId.Check} [check]
 * @returns {boolean}
 */
function passesCheck(number, check) {
    if (!check) {
        return true;
    }
    const algorithm = algorithms[check.algorithm];
    return Boolean(algorithm) && algorithm(number, check.params);
}

/**
 * @param {string} input
 * @param {HcpId.Rules} rules
 * @returns {HcpId.Result}
 */
export function verifyHcpId(input, rules) {
    const number = toCompactUpperCase(input);
    const isValid = new RegExp(rules.format).test(number) && passesCheck(number, rules.check);
    return { status: isValid ? HCP_ID_STATUS.VALID : HCP_ID_STATUS.INVALID, number };
}
